
import { useState, useRef, useEffect } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom'

//Components
import { Grid, Chip } from "@mui/material";
import {
    Modal,
    ModalBody,
    ModalFooter,
    Button,
    Tabs,
    TabContainer,
    Slider
} from "@gpstrackit/react-controls";

//Components
import AddCerebrumXOEM from 'Modules/accounts/.components/addCerebrumXOEM';


//Helpers
import { getCerebrumXStatus, getCerebrumXParameters } from 'Core/data/Helpers';

//Notification
import { NotificationManager } from "Components/Notifications";

//Styles
import './viewCerebrumXIntegration.scss';

//Security
import { HasPermission } from "Core/security";

//Actions
import {
    viewCerebrumXRequest,
    viewCerebrumXSaveProfileRequest,
    addOemOpenModal,
    clearRedux,
} from 'Redux/actions';
import { id } from "date-fns/locale";
import { set } from "lodash";

const ViewCerebrumXIntegration = (props) => {
    const { tableRef, company } = props;
    const { messages } = useIntl();
    const dispatch = useDispatch();
    const formRef = useRef(null);

    //Redux States
    const { loading, openModal, result, companyIntegration, fleet } = useSelector(state => state.viewCerebrumXIntegrationRedux)
    const openModalAddOEM = useSelector(state => state.addCerebrumXOEMRedux.openModal)
    const user = useSelector(state => state.securityRedux.user);


    //Local States
    const [tab, setTab] = useState(0);
    const [oems, setOems] = useState([]);
    const [activeSave, setActiveSave] = useState(false);
    const [harshAcceleration, setHarshAcceleration] = useState(3.61);
    const [harshBraking, setHarshBraking] = useState(-3.6);
    const [harshCornering, setHarshCornering] = useState(3.6);
    const [overspeeding, setOverspeeding] = useState(65);
    const [idling, setIdling] = useState(600);


    const closeModal = () => {

        dispatch(clearRedux("VIEW_CEREBRUMX_INTEGRATION"));
    }


    const applyChanges = () => {

        let payload = {
            companyIntegrationId: companyIntegration?.id,
            fleetId: companyIntegration?.externalId,
            spdLimit: overspeeding,
            harshBrakeRateLimit: harshBraking,
            rapidAccRateLimit: harshAcceleration,
            sharpTurnsRateLimit: harshCornering,
            idlingDurationLimit: idling
        }

        dispatch(viewCerebrumXSaveProfileRequest(payload))
    }

    useEffect(() => {

        if (result) {
            dispatch(clearRedux("add_integration", { result: null }))
            if (!result?.error) {
                NotificationManager.success(
                    messages['view_cerebrumx_integration_success_message'],
                    messages['view_cerebrumx_integration_title'],
                    3000
                );

                setActiveSave(false);
                closeModal();
                //tableRef && tableRef?.current?.getData();
            } else {
                NotificationManager.error(
                    messages['view_cerebrumx_integration_error_message'],
                    messages['view_cerebrumx_integration_title'],
                    3000
                );

            }
        }

        if (fleet && fleet?.thresholds) {
            dispatch(clearRedux("VIEW_CEREBRUMX_INTEGRATION", { fleet: null }));
            setHarshAcceleration(fleet?.thresholds?.rapidAccRateLimit);
            setHarshBraking(fleet?.thresholds?.harshBrakeRateLimit);
            setHarshCornering(fleet?.thresholds?.sharpTurnsRateLimit);
            setOverspeeding(fleet?.thresholds?.spdLimit);
            setIdling(fleet?.thresholds?.idlingDurationLimit);
        }
    }, [result, fleet])

    const updateOEMs = () => {
        dispatch(viewCerebrumXRequest(companyIntegration?.id))
    }

    return (
        <Modal
            open={openModal}
            title={messages['view_cerebrumx_integration_cerebrumx']}
            position="right"
            size="small"
            handleClose={closeModal}
            loading={loading}
        >
            <ModalBody>
                <Tabs
                    tab={+tab}
                    onChange={(event) => setTab(event)}
                >
                    <TabContainer index={0} label={messages['view_cerebrumx_integration_info']}>
                        <Grid item xs={12} style={{ marginTop: 11 }}>
                            <label style={{ marginRight: 5 }}>{messages['view_cerebrumx_integration_fleet']}:</label>
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: 11 }}>
                            <label className="input-normal-label" style={{ marginRight: 5 }}>{company?.name}</label>
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: 11 }}>
                            <label style={{ marginRight: 5 }}>{messages['view_cerebrumx_integration_fleet_id']}:</label>
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: 11 }}>
                            <label className="input-normal-label" style={{ marginRight: 5 }}>{companyIntegration?.externalId}</label>
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: 11 }}>
                            <label style={{ marginRight: 5 }}>{messages['view_cerebrumx_integration_status']}:</label>
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: 11 }}>
                            <Chip
                                label={getCerebrumXStatus(companyIntegration?.status, messages).name}
                                size="medium"
                                style={{
                                    backgroundColor: getCerebrumXStatus(companyIntegration?.status, messages).backgroundColor,
                                    color: "#ffffff"
                                }} />
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: 11 }}>
                            <label style={{ marginRight: 5 }}>{messages['view_cerebrumx_integration_oems']}:</label>
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: 11 }}>
                            {companyIntegration && getCerebrumXParameters(companyIntegration, messages)}
                        </Grid>
                        {
                           /*  HasPermission(user, "intgrtns", "u") &&
                            <Grid item xs={12} style={{ marginTop: 11, marginLeft: 15 }}>
                                <a
                                    type="link"
                                    href="#"
                                    style={{ cursor: 'pointer', marginRight: 5, marginTop: 2 }}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        dispatch(addOemOpenModal({ companyOems: companyIntegration?.parameters?.oems || [], companyIntegrationId: companyIntegration.id, fleetId: companyIntegration.externalId }))
                                    }}
                                >
                                    {messages['view_cerebrumx_integration_add_oem']}
                                </a>
                            </Grid> */
                        }
                    </TabContainer>
                    <TabContainer index={1} label={messages['view_cerebrumx_integration_thresholds']}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} style={{ marginTop: 10 }}>
                                <label className="input-normal-label" >{messages["view_cerebrumx_integration_harsh_acceleration"]}</label>
                                <Slider
                                    min={2}
                                    max={5}
                                    value={harshAcceleration}
                                    onChange={(event) => {
                                        setActiveSave(true);
                                        setHarshAcceleration(event)
                                    }}
                                    sliderOneColor
                                    sliderStep={0.01}
                                    showValue
                                    valueLabelDisplay="off"
                                    measure={messages["view_cerebrumx_integration_ms_square"]}
                                />
                                {messages["view_cerebrumx_integration_harsh_acceleration_range"]}
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: 10 }}>
                                <label className="input-normal-label" >{messages["view_cerebrumx_integration_harsh_breaking"]}</label>
                                <Slider
                                    min={-5}
                                    max={-2}
                                    value={harshBraking}
                                    onChange={(event) => {
                                        setActiveSave(true);
                                        setHarshBraking(event)
                                    }}
                                    sliderOneColor
                                    sliderStep={0.01}
                                    showValue
                                    valueLabelDisplay="off"
                                    measure={messages["view_cerebrumx_integration_ms_square"]}
                                />
                                {messages["view_cerebrumx_integration_harsh_breaking_range"]}
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: 10 }}>
                                <label className="input-normal-label" >{messages["view_cerebrumx_integration_harsh_cornering"]}</label>
                                <Slider
                                    min={2}
                                    max={5}
                                    value={harshCornering}
                                    onChange={(event) => {
                                        setActiveSave(true);
                                        setHarshCornering(event)
                                    }}
                                    sliderOneColor
                                    sliderStep={0.01}
                                    showValue
                                    valueLabelDisplay="off"
                                    measure={messages["view_cerebrumx_integration_ms_square"]}
                                />
                                {messages["view_cerebrumx_integration_harsh_cornering_range"]}
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: 10 }}>
                                <label className="input-normal-label" >{messages["view_cerebrumx_integration_overspeeding"]}</label>
                                <Slider
                                    min={40}
                                    max={150}
                                    value={overspeeding}
                                    onChange={(event) => {
                                        setActiveSave(true);
                                        setOverspeeding(event)
                                    }}
                                    sliderOneColor
                                    showValue
                                    valueLabelDisplay="off"
                                    measure={messages["view_cerebrumx_integration_mph"]}
                                />
                                {messages["view_cerebrumx_integration_overspeeding_range"]}
                            </Grid>
                            <Grid item xs={12} style={{ marginTop: 10 }}>
                                <label className="input-normal-label" >{messages["view_cerebrumx_integration_idling"]}</label>
                                <Slider
                                    min={60}
                                    max={1800}
                                    value={idling}
                                    onChange={(event) => {
                                        setActiveSave(true);
                                        setIdling(event)
                                    }}
                                    sliderOneColor
                                    showValue
                                    valueLabelDisplay="off"
                                    measure={messages["view_cerebrumx_integration_sec"]}
                                />
                                {messages["view_cerebrumx_integration_idling_range"]}
                            </Grid>
                        </Grid>
                    </TabContainer>
                </Tabs>
                {
                    openModalAddOEM && <AddCerebrumXOEM companyIntegration={companyIntegration} updateOEMs={updateOEMs} tableRef={tableRef} />
                }
            </ModalBody>
            <ModalFooter>
                {
                    <Button
                        className="btn-cancel"
                        onClick={() => closeModal()}
                    >
                        {messages['common_cancel']}
                    </Button>
                }
                {
                    tab === 1 && activeSave && HasPermission(user, "intgrtns", "u") &&
                    <Button
                        className="btn-dark-blue"
                        onClick={() => {
                            applyChanges()
                        }}
                    >
                        {messages['view_cerebrumx_integration_save_profiles']}
                    </Button>
                }
            </ModalFooter>
        </Modal >
    )
}

export default ViewCerebrumXIntegration;